module.exports = __webpack_public_path__ + "static/media/2.fcfe2bd1.png";